import { createGlobalStyle, ThemeProvider } from 'styled-components';
import { BrowserRouter } from 'react-router-dom';

import 'antd/dist/antd.min.css';

import themeGet from '@styled-system/theme-get';
import AppRoutes from './settings/routes';
import theme from './themes/default.theme';

import Integrations from './context/integrations';

const GlobalStyle = createGlobalStyle`
  body {
    font-family: ${themeGet('fontFamily')};
    overflow-y: hidden;
    background-color: ${themeGet('color.background')};
  }
`;

function App() {
    return (
        <ThemeProvider theme={theme}>
            <BrowserRouter>
                <Integrations>
                    <GlobalStyle />
                    <AppRoutes />
                </Integrations>
            </BrowserRouter>
        </ThemeProvider>
    );
}

export default App;
